<template>
    <div class="odds-row">
        <span class="odds-box" :class="[getOdd1x2UniqueId_1(event,'odA')]">
            <template v-if="checkLock(event.od,'odA')">
                <img src="assets/images/score/match-icon-lock.svg" class="icon-lock standard">
            </template>
            <template v-else>
                <span class="odds-number" v-if="oddsTitle">1</span>
                <odd1x2 :event="event" :bmk="bmk" :plyType="plytyp" :betType="bettyp" :type="type" :team="'odA'" :uid="getOdd1x2UniqueId_1(event,'odA')" :isAllBet="false"/>
            </template>
        </span>
        <span class="odds-box" :class="[getOdd1x2UniqueId_1(event,'odX')]" v-if="event.sptid == 1">
            <template v-if="checkLock(event.od,'odX')">
                <img src="assets/images/score/match-icon-lock.svg" class="icon-lock standard">
            </template>
            <template v-else>
                <span class="odds-number" v-if="oddsTitle">x</span>
                <odd1x2 :event="event" :bmk="bmk" :plyType="plytyp" :betType="bettyp" :type="type" :team="'odX'" :uid="getOdd1x2UniqueId_1(event,'odX')" :isAllBet="false"/>
            </template>
        </span>
        <span class="odds-box" :class="[getOdd1x2UniqueId_1(event,'odB')]">
            <template v-if="checkLock(event.od,'odB')">
                <img src="assets/images/score/match-icon-lock.svg" class="icon-lock standard">
            </template>
            <template v-else>
                <span class="odds-number" v-if="oddsTitle">2</span>
                <odd1x2 :event="event" :bmk="bmk" :plyType="plytyp" :betType="bettyp" :type="type" :team="'odB'" :uid="getOdd1x2UniqueId_1(event,'odB')" :isAllBet="false"/>
            </template>
        </span>
    </div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import allBet from '@/vue/mixins/allBet'

export default {
    mixins: [allBet],
    props:{
        oddsTitle: {
            type: Boolean,
            default: false
        },
        event: null,
        bmk: null,
        plytyp: null,
        bettyp: null,
        type: null,
    },
    computed:{
        ...mapGetters([
            'arr_selectedTemplate',
            'sportTableLang',
            'int_marketToggle',
            'editionStand'
        ])
    },
    data() {
        return {
            lang: window.lang,
            sumOdds: 0,
        }
    },
    methods:{
        // check_odds(od,team,plytyp,bettyp){
        //     if(od[plytyp]){
        //         if(od[plytyp][bettyp] && od[plytyp][bettyp]['odds'+team] && this.checkOddValidation(parseFloat(od[plytyp][bettyp]['odds'+team]))){
        //             return 'have-on';
        //         }
        //     }
        //     return ''  
        // },
        // modifyTitle(sportId){
        //     if(sportId != '1' && sportId != '19'){
        //         return this.sportAllBetLang['ALL_BET.SUBHEADER_ML']
        //     }else{
        //         return this.sportAllBetLang['ALL_BET.SUBHEADER_1x2']
        //         //return '1X2'
        //     }
        // },
        // betForm(event,bettype,team,playtype){
        //     if(this.$store.getters.account.previewFlag){
        //         return
        //     }
        //     var team_check= team=='x'?'d':team;
        //     var uniqueId = event.eveid + playtype + bettype + team_check
        //     //alert(bettype)
        //     if(this.$store.getters.bettingSelection.uniqueId == uniqueId){
        //         return
        //     }
        //     if(event.od[playtype] && event.od[playtype][bettype] && event.od[playtype][bettype]['odds'+team_check] && this.checkOddValidation(parseFloat(event.od[playtype][bettype]['odds'+team_check]))){
        //         if(bettype == this.mlBetType || bettype == this.rmlBetType){
        //             if(team == this.teamHome){
        //               //  team = this.ta
        //             }else if(team == this.teamAway){
        //               //  team = this.tb
        //             }
        //         }
        //         this.$store.dispatch('preBetForm', {
        //             event: event,
        //             bettype:bettype,
        //             team: team,
        //             playtype: playtype,
        //             uniqueId: event.eveid + playtype + bettype + team_check,
        //             marketToggle: this.int_marketToggle,
        //         })
        //     }else{
        //         return
        //     }
        // },
        // checkOddValidation(value) {
        //     if(this.$store.getters.account.oddsType=='am'){
        //         var pass_value= parseFloat(value);
        //         if(pass_value<0){
        //             pass_value=Math.abs(100/pass_value);
        //         }else{
        //             pass_value=pass_value/100;
        //         }
        //         pass_value=pass_value.toFixed(3);
        //         if(pass_value<=0){
        //             return false;
        //         }
        //     }else{
        //         if(parseFloat(value)<1){
        //             return false;
        //         }
        //     }
            
        //     return true;
        // },
        checkLock(od,team) {
            // let on = this.check_odds(od,team,plytyp,bettyp)

            // if(on == ''){
            //     return true
            // }

            if(od[team]){
                return false
            }
            return true
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/score/vue/apps/sport/oddsTable/odds1x2.vue